import { combineReducers } from "redux";

import { IStoreState } from "./initialStoreState";
import {
  UPSERT_ITEM_IN_LIST,
  UPSERT_LIST_CONFIG,
  applyUpsertToSlice,
} from "./common/upsertInList";
import { messageReducer } from "./messages/messagesReducer";

import { commonReducer } from "./common/commonReducer";

import { UserProfileReducer } from "./UserProfileList/userProfileReducer";

import { activityReducer } from "./activity/activityReducer";
import { customizerReducer } from "./customizer/customizerReducer";
import { leadsReducer } from "./leads/leadsReducer";
import { opportunitesReducer } from "./opportunites/opportunitesReducer";
import { studentReducer } from "./student/studentReducer";
import { templateReducer } from "./templates/templateReducer";

import { securityReducer } from "./security/securityReducer";
import { userDocumentReducer } from "./userDocument/userDocumentReducer";
import { userBranchReducer } from "./userBranch/userBranchReducer";
import { envConfigReducer } from "./envConfig/envConfigReducer";
import { companyInformationReducer } from "./CompanyInformation/companyInformationReducer";
import { bookingReducer } from "./booking/bookingReducer";
import { categoryReducer } from "./category/categoryReducer";
import { categoryTypeReducer } from "./categoryType/categoryTypeReducer";
import { foodReducer } from "./food/foodReducer";
import { marketCampaignReducer } from "./marketCampaign/marketCampaignReducer";
import { googleReviewReducer } from "./Review/reviewReducer";
import { companyOutletReducer } from "./companyOutlet/companyOutletReducer";
import { eventsReducer } from "./events/eventsReducer";
import { auctionReducer } from "./auction/auctionReducer";
import { partnersReducer } from "./partners/Partners.reducer";
import { onlineDsaLimitReducer } from "./OnlineDsaLimit";
import { leadsfromWebsiteReducer } from "./leadsfromwebsite/leadsfromwebsiteReducer";
import { crossroadsLeadsReducer } from "./CrossroadsLeads/CrossroadsLeads.reducer";
import { callingReducer } from "./calling/calling.reducers";
import {marketingCampaignReducer} from "./market-Campaign/marketCampaignReducer"
import { campaignReducer } from "./campaign/campaign.reducers";
import {apiKeyReducer} from "./apikey/apikey.reducer"
import { rsaPackageReducer } from "./rsaPackages/rsaPacakages.reducers";
import { promocodeReducer } from "./promocode/promocode.reducer";
import { dispositionReducer } from "./disposition/disposition.reducer";
import { campaignReportsReducer } from "./CrossroadsLeads/CampaignReports/CampaignReports.reducer";
import { upsellLeadsReducer } from "./upsellLead/reducer";
import { whatsappTemplateReducer } from "./whatsappTemplate/whatsappTemplateReducer";
import { paInsuranceReducer } from "./paInsurance";
import { manageMembershipReducer } from "./manageMembership";
import { mechanicListReducer } from "./mechanicList";
import { complaintsReducer } from "./complaints/complaints.reducer";
import { lawyeredReducer } from "./lawyered/lawyered.reducer";

const appReducer = combineReducers({
	customizerReducer: customizerReducer,
	student: studentReducer,
	message: messageReducer,
	acitivty: activityReducer,
	security: securityReducer,

	templates: templateReducer,
onlineDsaLimit: onlineDsaLimitReducer,
	userprofile: UserProfileReducer,
	common: commonReducer,
	companyInformation: companyInformationReducer,
	leadsfromwebsite: leadsfromWebsiteReducer,
	opportunites: opportunitesReducer,
	leads: leadsReducer,
	companyOutlet: companyOutletReducer,
	userDocument: userDocumentReducer,
	userBranch: userBranchReducer,
	envConfig: envConfigReducer,
	booking: bookingReducer,
	category: categoryReducer,
	categoryType: categoryTypeReducer,
	food: foodReducer,
	marketCampaign: marketCampaignReducer, //redux -> marketCampaign (new)
	review: googleReviewReducer,
	events: eventsReducer,
	auction: auctionReducer,
	partners: partnersReducer,
	crossroadsLeads: crossroadsLeadsReducer,
	calling: callingReducer,
	marketingCampaign: marketingCampaignReducer,  //redux ->market-Campaign (old)
	campaign: campaignReducer,
	complaints: complaintsReducer,
	apikey: apiKeyReducer,
	rsaPackage: rsaPackageReducer,
	promocode: promocodeReducer,
	disposition: dispositionReducer,
	campaignReports: campaignReportsReducer,
	upsellLeads: upsellLeadsReducer,
	whatsappTemplate: whatsappTemplateReducer,
	paInsurance: paInsuranceReducer,
	manageMembership: manageMembershipReducer,
	mechanicList: mechanicListReducer,
	lawyered: lawyeredReducer,
});

export const rootReducer = (state: IStoreState | undefined, action: any) => {
	if (action.type === "USER_LOGOUT") {
		return appReducer(undefined, action);
	}
	if (action.type === UPSERT_ITEM_IN_LIST) {
		const { slice, item } = action.payload || {};
		const config = slice ? UPSERT_LIST_CONFIG[slice] : undefined;
		if (!config || !state) return appReducer(state, action);
		const currentSliceState = (state as unknown as Record<string, unknown>)[slice];
		const newSliceState = applyUpsertToSlice(
			currentSliceState,
			config.listPath,
			config.idKey,
			item || {}
		);
		return { ...state, [slice]: newSliceState };
	}
	return appReducer(state, action);
};
